import { useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../../helpers";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { useNavigate } from "react-router-dom";
import { useGetWaybills } from "../../../../../hooks/api/queries/useProcurement";

const useWaybills = () => {
  const queries = getUrlQuerysection();
  const {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByDate,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [isModal, setIsModal] = useState(false);
  const navigate = useNavigate();
  const {
    isLoading: isFetchingWaybills,
    data: waybills,
    refetch: handleFetchingWaybills,
  } = useGetWaybills(queries);
  return {
    isFetchingWaybills,
    storeList,
    metaDetails: waybills?.meta || {},
    waybills: waybills?.data || [],
    search,
    isModal,
    setSearch,
    filterBySearch,
    filterByDate,
    setIsModal,
    handleFetchingWaybills,
    filterByStoreId,
    gotoPage,
    navigate,
  };
};

export default useWaybills;
